import tw from 'twin.macro';
import 'styled-components/macro';

import { ChallengeTabType } from 'types/graphql';

import { ReactComponent as CodeIcon } from './images/code.svg';
import { ReactComponent as OpenInNewWindowIcon } from './images/open-in-new-window.svg';
import { ReactComponent as ShellIcon } from './images/shell.svg';
import { ReactComponent as WebIcon } from './images/web.svg';

export interface TabProps {
  title: string;
  type: ChallengeTabType;
  newWindow?: boolean;
  active?: boolean;
  onClickTab?(): void;
}

export const Tab = ({ title, type, newWindow = false, active = false, onClickTab }: TabProps) => (
  <button
    tw="
      flex
      items-center
      gap-1

      h-full
      px-2

      min-w-0
      shrink

      bg-blue
      text-base
      font-medium
      text-blue-lighter

      svg:(shrink-0 [width: 16px])
    "
    css={[active && tw`bg-[#1C2639] text-white`]}
    title={title}
    onClick={onClickTab}
  >
    <TabIcon type={type} newWindow={newWindow} />
    <span tw="whitespace-nowrap overflow-hidden text-ellipsis">{title}</span>
  </button>
);

interface TabIconProps {
  type: ChallengeTabType;
  newWindow: boolean;
}

const TabIcon = ({ type, newWindow }: TabIconProps) => {
  if (newWindow) {
    return <OpenInNewWindowIcon />;
  }

  switch (type) {
    case ChallengeTabType.Terminal:
      return <ShellIcon />;
    case ChallengeTabType.Code:
      return <CodeIcon />;
    case ChallengeTabType.External:
      return <OpenInNewWindowIcon />;
    case ChallengeTabType.Website:
    case ChallengeTabType.Service:
    default:
      return <WebIcon />;
  }
};
